// const apiUrl = 'http://3.111.184.49:3002/';
// //const apiUrl = 'http://localhost:5000/';
// //http://localhost:5000/'
const apiUrl = "https://web2.mybiocalculus.com/";
const apiUrl2 = "https://data.mybiocalculus.com/api/"; // For backup data retrieval
const apiUrl3 = "https://find.mybiocalculus.com/"; // For other API calls
const genevent = "https://web1.mybiocalculus.com/";
const apiUrl4 = "https://web.mybiocalculus.com:3002/";
export { apiUrl, apiUrl2, apiUrl3, genevent, apiUrl4 };